// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Home Page - Bento Grid Dashboard
 *
 * A modern dashboard layout using CSS Grid with varied card sizes
 * for visual rhythm and information hierarchy.
 */

.home-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 1rem;
}

.home-greeting {
  margin-bottom: 1.5rem;
}

.home-greeting h1 {
  font-size: 1.75rem;
  color: var(--color-text-on-background, #ffffff);
  margin: 0 0 0.25rem 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.home-greeting p {
  font-size: 1rem;
  color: var(--color-text-on-background, #ffffff);
  opacity: 0.9;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Bento Grid Layout */
.bento-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1rem;
}

/* Card Base Styles */
.bento-card {
  background: var(--color-card-bg, #ffffff);
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.bento-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.bento-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.bento-card-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-text-secondary, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bento-card-icon {
  font-size: 1.1rem;
}

/* Card Size Variants - width only, height auto-sizes to content */
.bento-card--large {
  grid-column: span 8;
}

.bento-card--medium {
  grid-column: span 4;
}

.bento-card--wide {
  grid-column: span 8;
}

.bento-card--small {
  grid-column: span 4;
}

/* === Today's Prompt Card === */
.todays-prompt-card {
  background: linear-gradient(135deg, var(--color-yellow-gradient-start, #F5FBC2), var(--color-yellow-gradient-end, #F0E266));
  border: 2px solid var(--color-yellow-gradient-end, #F0E266);
}

.todays-prompt-card .view-all-link {
  color: var(--color-active-text, #1f2937);
  font-weight: 500;
}

.todays-prompt-card .bento-card-title {
  color: var(--color-active-text, #1f2937);
}

.todays-prompt-card .todays-prompt-category {
  color: var(--color-active-text, #1f2937);
  opacity: 0.8;
}

.todays-prompt-content {
  display: flex;
  flex-direction: column;
}

.todays-prompt-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-active-text, #1f2937);
  line-height: 1.4;
  margin: 0;
}

.todays-prompt-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.todays-prompt-category {
  font-size: 0.875rem;
  color: var(--color-text-secondary, #6b7280);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.todays-prompt-actions {
  display: flex;
  gap: 0.5rem;
}

/* === Stats Card === */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.stat-item {
  text-align: center;
  padding: 0.75rem;
  background: var(--color-background, #f3f4f6);
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-primary, #3b82f6);
  line-height: 1;
}

.stat-value.streak {
  color: var(--color-warning, #f59e0b);
}

.stat-value.success {
  color: var(--color-success, #10b981);
}

.stat-label {
  font-size: 0.75rem;
  color: var(--color-text-secondary, #6b7280);
  margin-top: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Storage usage in stats card */
.stat-storage {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--color-border, #e5e7eb);
}

.stat-storage-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.4rem;
}

.stat-storage-label {
  font-size: 0.75rem;
  color: var(--color-text-secondary, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.stat-storage-plan {
  font-size: 0.7rem;
  color: var(--color-text-secondary, #6b7280);
  font-style: italic;
}

.stat-storage-bar {
  height: 8px;
  background: var(--color-background, #f3f4f6);
  border-radius: 4px;
  overflow: hidden;
}

.stat-storage-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
  min-width: 2px;
}

.stat-storage-detail {
  font-size: 0.7rem;
  color: var(--color-text-secondary, #6b7280);
  margin-top: 0.25rem;
  text-align: right;
}

/* === Recent Reflections Card === */
.recent-reflections-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.recent-reflection-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--color-background, #f3f4f6);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s ease;
}

.recent-reflection-item:hover {
  background: var(--color-border-light, #e5e7eb);
}

.recent-reflection-thumbnail {
  width: 48px;
  height: 36px;
  background: var(--color-border, #d1d5db);
  border-radius: 0.375rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.recent-reflection-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recent-reflection-info {
  flex: 1 1;
  min-width: 0;
}

.recent-reflection-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text, #1f2937);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recent-reflection-date {
  font-size: 0.75rem;
  color: var(--color-text-secondary, #6b7280);
}

.recent-empty {
  text-align: center;
  padding: 2rem;
  color: var(--color-text-secondary, #6b7280);
}

/* === Quick Actions Card === */
.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.quick-action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: var(--color-background, #f3f4f6);
  border: none;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.quick-action-btn:hover {
  background: var(--color-primary, #3b82f6);
  color: white;
}

.quick-action-btn:hover .quick-action-icon,
.quick-action-btn:hover .quick-action-label {
  color: white;
}

.quick-action-icon {
  font-size: 1.5rem;
  color: var(--color-primary, #3b82f6);
  transition: color 0.2s ease;
}

.quick-action-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text, #1f2937);
  transition: color 0.2s ease;
}

/* === On This Day Card === */
.on-this-day-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.on-this-day-memory {
  padding: 0.75rem;
  background: var(--color-background, #f3f4f6);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s ease;
}

.on-this-day-memory:hover {
  background: var(--color-border-light, #e5e7eb);
}

.on-this-day-year {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-primary, #3b82f6);
  margin-bottom: 0.25rem;
}

.on-this-day-title {
  font-size: 0.875rem;
  color: var(--color-text, #1f2937);
}

.on-this-day-empty {
  text-align: center;
  padding: 1.5rem;
  color: var(--color-text-secondary, #6b7280);
  font-style: italic;
}

/* === Category Breakdown Card === */
.category-breakdown-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.category-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.category-item--clickable {
  cursor: pointer;
  padding: 0.5rem;
  margin: -0.5rem;
  border-radius: 0.5rem;
  transition: background 0.2s ease;
}

.category-item--clickable:hover {
  background: var(--color-background, #f3f4f6);
}

.category-item--clickable:focus-visible {
  outline: 2px solid var(--color-primary, #3b82f6);
  outline-offset: 2px;
}

.category-icon {
  font-size: 1.25rem;
  width: 1.5rem;
  text-align: center;
  flex-shrink: 0;
}

.category-name {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text, #1f2937);
  min-width: 4rem;
  flex-shrink: 0;
}

.category-bar-container {
  flex: 1 1;
  height: 0.5rem;
  background: var(--color-border-light, #e5e7eb);
  border-radius: 9999px;
  overflow: hidden;
}

.category-bar {
  height: 100%;
  background: var(--color-primary, #3b82f6);
  border-radius: 9999px;
  transition: width 0.3s ease;
}

.category-count {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text-secondary, #6b7280);
  min-width: 2rem;
  text-align: right;
}

/* Responsive Layout */
@media (max-width: 1024px) {
  .bento-card--large {
    grid-column: span 12;
  }

  .bento-card--medium {
    grid-column: span 6;
  }

  .bento-card--wide {
    grid-column: span 12;
  }

  .bento-card--small {
    grid-column: span 6;
  }
}

@media (max-width: 640px) {
  .home-container {
    padding: 1rem 0.75rem;
  }

  .bento-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .bento-card--large,
  .bento-card--medium,
  .bento-card--wide,
  .bento-card--small {
    grid-column: span 1;
  }

  .todays-prompt-text {
    font-size: 1.25rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-value {
    font-size: 1.5rem;
  }

  .quick-actions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* === Shared With Me Card === */
.shared-with-me-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.shared-with-me-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--color-text-secondary, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--color-border-light, #e5e7eb);
  margin-bottom: 0.25rem;
}

.shared-header-name {
  flex: 1 1;
}

.shared-header-total,
.shared-header-new {
  width: 3rem;
  text-align: center;
}

.shared-with-me-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background 0.2s ease;
}

.shared-with-me-item:hover {
  background: var(--color-background, #f3f4f6);
}

.shared-username {
  flex: 1 1;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text, #1f2937);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shared-username:hover {
  color: var(--color-primary, #3b82f6);
  text-decoration: underline;
}

.shared-username:focus-visible {
  outline: 2px solid var(--color-primary, #3b82f6);
  outline-offset: 2px;
  border-radius: 2px;
}

.shared-total-count {
  width: 3rem;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text-secondary, #6b7280);
  cursor: pointer;
}

.shared-total-count:hover {
  color: var(--color-primary, #3b82f6);
}

.shared-total-count:focus-visible {
  outline: 2px solid var(--color-primary, #3b82f6);
  outline-offset: 2px;
  border-radius: 2px;
}

.shared-new-count {
  width: 3rem;
  text-align: center;
  font-size: 0.875rem;
  color: var(--color-text-muted, #9ca3af);
}

.shared-new-count.has-new {
  font-weight: 600;
  color: var(--color-success, #10b981);
  cursor: pointer;
}

.shared-new-count.has-new:hover {
  color: var(--color-success-hover, #059669);
  text-decoration: underline;
}

.shared-new-count.has-new:focus-visible {
  outline: 2px solid var(--color-success, #10b981);
  outline-offset: 2px;
  border-radius: 2px;
}

/* Friend Suggestions Card - pending count column */
.friend-sugg-pending {
  width: 3rem;
  text-align: center;
  font-size: 0.875rem;
  color: var(--color-text-muted, #9ca3af);
}

.friend-sugg-pending.has-pending {
  font-weight: 600;
  color: var(--color-success, #10b981);
}

/* View All Link */
.view-all-link {
  font-size: 0.875rem;
  color: var(--color-primary, #3b82f6);
  text-decoration: none;
  cursor: pointer;
}

.view-all-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/Home.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,YAAY;EACZ,SAAS;EACT,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,2HAA2H;EAC3H,2DAA2D;AAC7D;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,4CAA4C;EAC5C,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,8CAA8C;EAC9C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;;;;IAIE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,sBAAsB;EACtB,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/**\n * Home Page - Bento Grid Dashboard\n *\n * A modern dashboard layout using CSS Grid with varied card sizes\n * for visual rhythm and information hierarchy.\n */\n\n.home-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem 1rem;\n}\n\n.home-greeting {\n  margin-bottom: 1.5rem;\n}\n\n.home-greeting h1 {\n  font-size: 1.75rem;\n  color: var(--color-text-on-background, #ffffff);\n  margin: 0 0 0.25rem 0;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.home-greeting p {\n  font-size: 1rem;\n  color: var(--color-text-on-background, #ffffff);\n  opacity: 0.9;\n  margin: 0;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n/* Bento Grid Layout */\n.bento-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 1rem;\n}\n\n/* Card Base Styles */\n.bento-card {\n  background: var(--color-card-bg, #ffffff);\n  border-radius: 1rem;\n  padding: 1.25rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.bento-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.bento-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.bento-card-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--color-text-secondary, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.bento-card-icon {\n  font-size: 1.1rem;\n}\n\n/* Card Size Variants - width only, height auto-sizes to content */\n.bento-card--large {\n  grid-column: span 8;\n}\n\n.bento-card--medium {\n  grid-column: span 4;\n}\n\n.bento-card--wide {\n  grid-column: span 8;\n}\n\n.bento-card--small {\n  grid-column: span 4;\n}\n\n/* === Today's Prompt Card === */\n.todays-prompt-card {\n  background: linear-gradient(135deg, var(--color-yellow-gradient-start, #F5FBC2), var(--color-yellow-gradient-end, #F0E266));\n  border: 2px solid var(--color-yellow-gradient-end, #F0E266);\n}\n\n.todays-prompt-card .view-all-link {\n  color: var(--color-active-text, #1f2937);\n  font-weight: 500;\n}\n\n.todays-prompt-card .bento-card-title {\n  color: var(--color-active-text, #1f2937);\n}\n\n.todays-prompt-card .todays-prompt-category {\n  color: var(--color-active-text, #1f2937);\n  opacity: 0.8;\n}\n\n.todays-prompt-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.todays-prompt-text {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-active-text, #1f2937);\n  line-height: 1.4;\n  margin: 0;\n}\n\n.todays-prompt-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.todays-prompt-category {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary, #6b7280);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.todays-prompt-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* === Stats Card === */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 0.75rem;\n  background: var(--color-background, #f3f4f6);\n  border-radius: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--color-primary, #3b82f6);\n  line-height: 1;\n}\n\n.stat-value.streak {\n  color: var(--color-warning, #f59e0b);\n}\n\n.stat-value.success {\n  color: var(--color-success, #10b981);\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--color-text-secondary, #6b7280);\n  margin-top: 0.25rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Storage usage in stats card */\n.stat-storage {\n  margin-top: 1rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--color-border, #e5e7eb);\n}\n\n.stat-storage-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 0.4rem;\n}\n\n.stat-storage-label {\n  font-size: 0.75rem;\n  color: var(--color-text-secondary, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n\n.stat-storage-plan {\n  font-size: 0.7rem;\n  color: var(--color-text-secondary, #6b7280);\n  font-style: italic;\n}\n\n.stat-storage-bar {\n  height: 8px;\n  background: var(--color-background, #f3f4f6);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.stat-storage-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n  min-width: 2px;\n}\n\n.stat-storage-detail {\n  font-size: 0.7rem;\n  color: var(--color-text-secondary, #6b7280);\n  margin-top: 0.25rem;\n  text-align: right;\n}\n\n/* === Recent Reflections Card === */\n.recent-reflections-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.recent-reflection-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: var(--color-background, #f3f4f6);\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.recent-reflection-item:hover {\n  background: var(--color-border-light, #e5e7eb);\n}\n\n.recent-reflection-thumbnail {\n  width: 48px;\n  height: 36px;\n  background: var(--color-border, #d1d5db);\n  border-radius: 0.375rem;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.recent-reflection-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.recent-reflection-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.recent-reflection-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-text, #1f2937);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.recent-reflection-date {\n  font-size: 0.75rem;\n  color: var(--color-text-secondary, #6b7280);\n}\n\n.recent-empty {\n  text-align: center;\n  padding: 2rem;\n  color: var(--color-text-secondary, #6b7280);\n}\n\n/* === Quick Actions Card === */\n.quick-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n\n.quick-action-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: var(--color-background, #f3f4f6);\n  border: none;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n\n.quick-action-btn:hover {\n  background: var(--color-primary, #3b82f6);\n  color: white;\n}\n\n.quick-action-btn:hover .quick-action-icon,\n.quick-action-btn:hover .quick-action-label {\n  color: white;\n}\n\n.quick-action-icon {\n  font-size: 1.5rem;\n  color: var(--color-primary, #3b82f6);\n  transition: color 0.2s ease;\n}\n\n.quick-action-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--color-text, #1f2937);\n  transition: color 0.2s ease;\n}\n\n/* === On This Day Card === */\n.on-this-day-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.on-this-day-memory {\n  padding: 0.75rem;\n  background: var(--color-background, #f3f4f6);\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.on-this-day-memory:hover {\n  background: var(--color-border-light, #e5e7eb);\n}\n\n.on-this-day-year {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-primary, #3b82f6);\n  margin-bottom: 0.25rem;\n}\n\n.on-this-day-title {\n  font-size: 0.875rem;\n  color: var(--color-text, #1f2937);\n}\n\n.on-this-day-empty {\n  text-align: center;\n  padding: 1.5rem;\n  color: var(--color-text-secondary, #6b7280);\n  font-style: italic;\n}\n\n/* === Category Breakdown Card === */\n.category-breakdown-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.category-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.category-item--clickable {\n  cursor: pointer;\n  padding: 0.5rem;\n  margin: -0.5rem;\n  border-radius: 0.5rem;\n  transition: background 0.2s ease;\n}\n\n.category-item--clickable:hover {\n  background: var(--color-background, #f3f4f6);\n}\n\n.category-item--clickable:focus-visible {\n  outline: 2px solid var(--color-primary, #3b82f6);\n  outline-offset: 2px;\n}\n\n.category-icon {\n  font-size: 1.25rem;\n  width: 1.5rem;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.category-name {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--color-text, #1f2937);\n  min-width: 4rem;\n  flex-shrink: 0;\n}\n\n.category-bar-container {\n  flex: 1;\n  height: 0.5rem;\n  background: var(--color-border-light, #e5e7eb);\n  border-radius: 9999px;\n  overflow: hidden;\n}\n\n.category-bar {\n  height: 100%;\n  background: var(--color-primary, #3b82f6);\n  border-radius: 9999px;\n  transition: width 0.3s ease;\n}\n\n.category-count {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--color-text-secondary, #6b7280);\n  min-width: 2rem;\n  text-align: right;\n}\n\n/* Responsive Layout */\n@media (max-width: 1024px) {\n  .bento-card--large {\n    grid-column: span 12;\n  }\n\n  .bento-card--medium {\n    grid-column: span 6;\n  }\n\n  .bento-card--wide {\n    grid-column: span 12;\n  }\n\n  .bento-card--small {\n    grid-column: span 6;\n  }\n}\n\n@media (max-width: 640px) {\n  .home-container {\n    padding: 1rem 0.75rem;\n  }\n\n  .bento-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .bento-card--large,\n  .bento-card--medium,\n  .bento-card--wide,\n  .bento-card--small {\n    grid-column: span 1;\n  }\n\n  .todays-prompt-text {\n    font-size: 1.25rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .stat-value {\n    font-size: 1.5rem;\n  }\n\n  .quick-actions-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* === Shared With Me Card === */\n.shared-with-me-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.shared-with-me-header {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--color-text-secondary, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--color-border-light, #e5e7eb);\n  margin-bottom: 0.25rem;\n}\n\n.shared-header-name {\n  flex: 1;\n}\n\n.shared-header-total,\n.shared-header-new {\n  width: 3rem;\n  text-align: center;\n}\n\n.shared-with-me-item {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  transition: background 0.2s ease;\n}\n\n.shared-with-me-item:hover {\n  background: var(--color-background, #f3f4f6);\n}\n\n.shared-username {\n  flex: 1;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-text, #1f2937);\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.shared-username:hover {\n  color: var(--color-primary, #3b82f6);\n  text-decoration: underline;\n}\n\n.shared-username:focus-visible {\n  outline: 2px solid var(--color-primary, #3b82f6);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.shared-total-count {\n  width: 3rem;\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-text-secondary, #6b7280);\n  cursor: pointer;\n}\n\n.shared-total-count:hover {\n  color: var(--color-primary, #3b82f6);\n}\n\n.shared-total-count:focus-visible {\n  outline: 2px solid var(--color-primary, #3b82f6);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.shared-new-count {\n  width: 3rem;\n  text-align: center;\n  font-size: 0.875rem;\n  color: var(--color-text-muted, #9ca3af);\n}\n\n.shared-new-count.has-new {\n  font-weight: 600;\n  color: var(--color-success, #10b981);\n  cursor: pointer;\n}\n\n.shared-new-count.has-new:hover {\n  color: var(--color-success-hover, #059669);\n  text-decoration: underline;\n}\n\n.shared-new-count.has-new:focus-visible {\n  outline: 2px solid var(--color-success, #10b981);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n/* Friend Suggestions Card - pending count column */\n.friend-sugg-pending {\n  width: 3rem;\n  text-align: center;\n  font-size: 0.875rem;\n  color: var(--color-text-muted, #9ca3af);\n}\n\n.friend-sugg-pending.has-pending {\n  font-weight: 600;\n  color: var(--color-success, #10b981);\n}\n\n/* View All Link */\n.view-all-link {\n  font-size: 0.875rem;\n  color: var(--color-primary, #3b82f6);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.view-all-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
